// Custom hamburger menu implementation - Desktop only
document.addEventListener('DOMContentLoaded', function() {
    // Only run on desktop (screens 990px and wider)
    if (window.innerWidth >= 990) {
        // Function to create menu HTML from existing navigation
        function createMenuHTML() {
            const existingMenu = document.querySelector('.header-menu-list-sections--19092481605883__ss_header_1_TMQAFP');
            
            if (existingMenu) {
                let menuHTML = '';
                
                // Get all top-level menu items
                const topLevelItems = existingMenu.children;
                
                Array.from(topLevelItems).forEach(item => {
                    const mainLink = item.querySelector(':scope > .header-menu-link-sections--19092481605883__ss_header_1_TMQAFP');
                    const megaMenu = item.querySelector('.header-mega-menu-sections--19092481605883__ss_header_1_TMQAFP');
                    
                    if (mainLink) {
                        menuHTML += '<div class="custom-menu-item">';
                        
                        // Add main menu link
                        const href = mainLink.getAttribute('href');
                        const text = mainLink.textContent.trim();
                        menuHTML += `<a href="${href}" class="custom-menu-link">${text.toUpperCase()}</a>`;
                        
                        // Check for submenu items
                        if (megaMenu) {
                            menuHTML += '<div class="custom-submenu">';
                            
                            // Get all submenu links
                            const submenuItems = megaMenu.querySelectorAll('.header-menu-item-sections--19092481605883__ss_header_1_TMQAFP a');
                            submenuItems.forEach(subLink => {
                                const subHref = subLink.getAttribute('href');
                                const subText = subLink.textContent.trim();
                                menuHTML += `<a href="${subHref}" class="custom-submenu-link">${subText}</a>`;
                            });
                            
                            menuHTML += '</div>';
                        }
                        
                        menuHTML += '</div>';
                    }
                });
                
                return menuHTML;
            } else {
                // Fallback if menu structure not found
                console.warn('Menu structure not found, using fallback');
                return '<div class="custom-menu-item"><a href="/" class="custom-menu-link">HOME</a></div>';
            }
        }
        
        // Create custom menu elements
        const menuDrawer = document.createElement('div');
        menuDrawer.className = 'custom-menu-drawer';
        menuDrawer.innerHTML = createMenuHTML();
        
        const menuOverlay = document.createElement('div');
        menuOverlay.className = 'custom-menu-overlay';
        
        // Add to body
        document.body.appendChild(menuDrawer);
        document.body.appendChild(menuOverlay);
        
        // Handle submenu toggles
        const menuItems = menuDrawer.querySelectorAll('.custom-menu-item');
        menuItems.forEach(item => {
            const mainLink = item.querySelector('.custom-menu-link');
            const submenu = item.querySelector('.custom-submenu');
            
            if (submenu) {
                // Add arrow indicator
                mainLink.innerHTML += ' <span class="submenu-arrow">▼</span>';
                
                // Toggle submenu on click
                mainLink.addEventListener('click', function(e) {
                    // If href is # or empty, prevent navigation
                    if (mainLink.getAttribute('href') === '#' || mainLink.getAttribute('href') === '') {
                        e.preventDefault();
                    }
                    
                    // Toggle submenu
                    submenu.classList.toggle('open');
                    const arrow = mainLink.querySelector('.submenu-arrow');
                    if (arrow) {
                        arrow.textContent = submenu.classList.contains('open') ? '▲' : '▼';
                    }
                });
            }
        });
        
        // Handle hamburger click
        const hamburger = document.querySelector('.header-menu-icon-sections--19092481605883__ss_header_1_TMQAFP');
        
        if (hamburger) {
            hamburger.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                menuDrawer.classList.toggle('open');
                menuOverlay.classList.toggle('open');
            });
        }
        
        // Close on overlay click
        menuOverlay.addEventListener('click', function() {
            menuDrawer.classList.remove('open');
            menuOverlay.classList.remove('open');
            // Close all submenus when closing drawer
            const allSubmenus = menuDrawer.querySelectorAll('.custom-submenu.open');
            allSubmenus.forEach(submenu => {
                submenu.classList.remove('open');
                const arrow = submenu.previousElementSibling.querySelector('.submenu-arrow');
                if (arrow) arrow.textContent = '▼';
            });
        });
        
        // Close on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                menuDrawer.classList.remove('open');
                menuOverlay.classList.remove('open');
                // Close all submenus when closing drawer
                const allSubmenus = menuDrawer.querySelectorAll('.custom-submenu.open');
                allSubmenus.forEach(submenu => {
                    submenu.classList.remove('open');
                    const arrow = submenu.previousElementSibling.querySelector('.submenu-arrow');
                    if (arrow) arrow.textContent = '▼';
                });
            }
        });
        
        // Listen for Shopify theme editor changes
        document.addEventListener('shopify:section:load', function() {
            // Recreate menu when theme editor updates
            const newMenuHTML = createMenuHTML();
            const menuDrawer = document.querySelector('.custom-menu-drawer');
            if (menuDrawer) {
                menuDrawer.innerHTML = newMenuHTML;
                // Reattach event listeners to new elements
                const menuItems = menuDrawer.querySelectorAll('.custom-menu-item');
                menuItems.forEach(item => {
                    const mainLink = item.querySelector('.custom-menu-link');
                    const submenu = item.querySelector('.custom-submenu');
                    
                    if (submenu) {
                        mainLink.innerHTML += ' <span class="submenu-arrow">▼</span>';
                        mainLink.addEventListener('click', function(e) {
                            if (mainLink.getAttribute('href') === '#' || mainLink.getAttribute('href') === '') {
                                e.preventDefault();
                            }
                            submenu.classList.toggle('open');
                            const arrow = mainLink.querySelector('.submenu-arrow');
                            if (arrow) {
                                arrow.textContent = submenu.classList.contains('open') ? '▲' : '▼';
                            }
                        });
                    }
                });
            }
        });
    }
});